import fetcher from '@/utils/fetcher';

type EmailStatusType =
'email exists with password'
| 'email exists without password'
| 'email does not exist'
| 'not email format'
| 'error' //

/**  가입된 이메일인지 확인 */
const postCheckEmailStatus = async (email: string) => {
  try {
    const res = await fetcher.post('/api/auth/check-email', { data: { email } });
    return res.data.data as EmailStatusType;
  } catch (e) {
    return 'error';
  }
};

export default postCheckEmailStatus;
